module.exports = __webpack_public_path__ + "img/arrow-left-circle.513ae29a.svg";